import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Typography,
  Box,
  Chip,
} from '@mui/material';
import { required, useTranslate } from 'react-admin';
import type { ExpiryTimeGranularity } from '@x-guard/xgac-types/xgac';
import type { DocumentAssignee } from '../../../utils/certificationDocuments';
import { GrayDateInputWithUpperLabel } from './inputs/GrayDateInputWithUpperLabel';
import { ExpiryDateDisplay } from './ExpiryDateDisplay';
import { TimeGranularityLabel } from '../../../utils/timeGranularityUtils';

const CertificationDatesTableRow = (props: {
  recipient: DocumentAssignee;
  timeGranularity: ExpiryTimeGranularity;
}) => {

  const { recipient, timeGranularity } = props;
  const base = `certificationsByAssetId.${recipient.id}`;

  return (
    <TableRow key={recipient.id}>
      <TableCell>{recipient.label}</TableCell>
      <TableCell>
        <GrayDateInputWithUpperLabel
          source={`${base}.firstIssuedOn`}
          label={false}
          validate={required()}
          helperText={false}
          size="small"
        />
      </TableCell>
      <TableCell colSpan={2}>
        <ExpiryDateDisplay
          startDateSource={`${base}.lastReceivedOn`}
          expiryDateSource={`${base}.expiryDate`}
          timeGranularity={timeGranularity}
          usage="table"
        />
      </TableCell>
    </TableRow>
  );

};

export const CertifiedUsersDatesStep = (props: {
  recipients: DocumentAssignee[];
  timeGranularity: ExpiryTimeGranularity;
}) => {

  const translate = useTranslate();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{translate('general.fields.name')}</TableCell>
            <TableCell>{translate('resources.assets.certifications.fields.first_issued_on')}</TableCell>
            <TableCell colSpan={2}>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'minmax(0, 1fr) max-content minmax(0, 1fr)',
                  columnGap: 2,
                  width: '70%',
                }}
              >
                <Typography variant="body2" fontWeight={500}>
                  {translate('resources.assets.certifications.fields.last_received_on')}
                </Typography>
                {/* This was added to match the width of the expiry date display inputs below */}
                <Chip
                  label={TimeGranularityLabel(props.timeGranularity, translate)}
                  sx={{ visibility: 'hidden' }}
                />
                <Typography variant="body2" fontWeight={500} textAlign="center">
                  {translate('resources.assets.certifications.fields.expiry_date')}
                </Typography>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.recipients.map((recipient) => {

            return <CertificationDatesTableRow key={recipient.id} recipient={recipient} timeGranularity={props.timeGranularity} />;

          })}
        </TableBody>
      </Table>
    </TableContainer>
  );

};
